module.exports = __webpack_public_path__ + "img/reload-light.df2200d7.svg";